
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Route } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "./AppTopbar";
import { AppFooter } from "./AppFooter";

import { Dashboard } from "./components/Dashboard";
import { ChequeCulture } from "./components/ChequeCulture";
import { RetourBoutique } from "./components/RetourBoutique";
import { ServiceIndisponible } from "./components/ServiceIndisponible";
import { DemandeClap } from "./components/forms/clap/DemandeClap";

import { EaLegacyAccueil } from "./components/EaLegacyAccueil";
import { SessionExpire } from "./components/SessionExpire";
import { PrePaiement } from "./components/PrePaiement";
//import { ServiceIndisponible } from "./components/ServiceIndisponible";

import { ChoixFormulairePrestation } from "./components/forms/clap/ChoixFormulairePrestation";
import { ChoixPeriode } from "./components/forms/clap/ChoixPeriode";

import { DemandeVacances } from "./components/forms/vacance/DemandeVacances";
import { ChoixPeriodeVacances } from "./components/forms/vacance/ChoixPeriodeVacances";

import { DemandeSport } from "./components/forms/sport/DemandeSport";
import { ChoixPeriodeSport } from "./components/forms/sport/ChoixPeriodeSport";
import { DemandeChangementRib } from "./components/forms/ribAgentUpdate/DemandeChangementRib";
import { ChoixRib } from "./components/forms/ribAgentUpdate/ChoixRib";

import PrimeReact from "primereact/api";
import { Dialog } from "primereact/dialog";
import { onJweExpired } from "./service/JweSession";
import { ChequeCultureService } from "./service/ChequeCultureService";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./layout/flags/flags.css";
import "./layout/layout.scss";
import "./App.scss";
import { DemandeTitreCulture } from "./components/forms/titre_culture/DemandeTitreCulture";
import { DemandeAncv } from "./components/forms/ancv/DemandeAncv";
import { ChoixPeriodeAncv } from "./components/forms/ancv/ChoixPeriodeAncv";
import { DemandeCesu } from "./components/forms/cesu/DemandeCesu";
import { ChoixPeriodeCesu } from "./components/forms/cesu/ChoixPeriodeCesu";
import { DemandeCesuMulti} from "./components/forms/cesuMulti/DemandeCesuMulti";
import { ChoixPeriodeCesuMulti } from "./components/forms/cesuMulti/ChoixPeriodeCesuMulti";

const App = () => {
  const [layoutMode, setLayoutMode] = useState("static");
  const [layoutColorMode, setLayoutColorMode] = useState("light");
  const [inputStyle, setInputStyle] = useState("outlined");
  const [ripple, setRipple] = useState(true);
  const [staticMenuInactive, setStaticMenuInactive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);

  PrimeReact.ripple = true;

  const [jweExpired, setJweExpired] = useState(false);
  const chequeCultureService = new ChequeCultureService();

  let menuClick = false;
  let mobileTopbarMenuClick = false;

  useEffect(() => {
    if (mobileMenuActive) {
      addClass(document.body, "body-overflow-hidden");
    } else {
      removeClass(document.body, "body-overflow-hidden");
    }
  }, [mobileMenuActive]);

  // Handoff EA legacy -> NEA : le JWE peut expirer pendant que l'agent remplit un formulaire.
  // L'événement est diffusé par l'intercepteur axios (installJweExpiredInterceptor) quel que
  // soit le formulaire affiché ; on affiche donc ce dialog au niveau racine de l'app.
  useEffect(() => {
    return onJweExpired(() => setJweExpired(true));
  }, []);

  const onRetourAccueilJweExpired = () => {
    chequeCultureService.redirectEaLegacyAccueil();
  };

  const onWrapperClick = (event) => {
    if (!menuClick) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }

    if (!mobileTopbarMenuClick) {
      setMobileTopbarMenuActive(false);
    }

    mobileTopbarMenuClick = false;
    menuClick = false;
  };

  const onToggleMenuClick = (event) => {
    menuClick = true;

    if (isDesktop()) {
      if (layoutMode === "overlay") {
        if (mobileMenuActive === true) {
          setOverlayMenuActive(true);
        }

        setOverlayMenuActive((prevState) => !prevState);
        setMobileMenuActive(false);
      } else if (layoutMode === "static") {
        setStaticMenuInactive((prevState) => !prevState);
      }
    } else {
      setMobileMenuActive((prevState) => !prevState);
    }

    event.preventDefault();
  };

  const onMobileTopbarMenuClick = (event) => {
    mobileTopbarMenuClick = true;

    setMobileTopbarMenuActive((prevState) => !prevState);
    event.preventDefault();
  };

  const onMobileSubTopbarMenuClick = (event) => {
    mobileTopbarMenuClick = true;

    event.preventDefault();
  };

  const isDesktop = () => {
    return window.innerWidth >= 992;
  };

  const addClass = (element, className) => {
    if (element.classList) element.classList.add(className);
    else element.className += " " + className;
  };

  const removeClass = (element, className) => {
    if (element.classList) element.classList.remove(className);
    else
      element.className = element.className.replace(
        new RegExp(
          "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
          "gi"
        ),
        " "
      );
  };

  const wrapperClass = classNames("layout-wrapper", {
    "layout-overlay": layoutMode === "overlay",
    "layout-static": layoutMode === "static",
    "layout-static-sidebar-inactive":
      staticMenuInactive && layoutMode === "static",
    "layout-overlay-sidebar-active":
      overlayMenuActive && layoutMode === "overlay",
    "layout-mobile-sidebar-active": mobileMenuActive,
    "p-input-filled": inputStyle === "filled",
    "p-ripple-disabled": ripple === false,
    "layout-theme-light": layoutColorMode === "light",
  });

  return (
    <div className={wrapperClass} onClick={onWrapperClick}>
      <AppTopbar
        onToggleMenuClick={onToggleMenuClick}
        layoutColorMode={layoutColorMode}
        mobileTopbarMenuActive={mobileTopbarMenuActive}
        onMobileTopbarMenuClick={onMobileTopbarMenuClick}
        onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick}
      />



      <div className="layout-main-container" id="mainLayout">
        <div className="layout-main">
          <Route path="/" exact component={Dashboard} />
          <Route path="/chequeculture/:mode" component={DemandeTitreCulture} />
          <Route path="/retourboutique" component={RetourBoutique} />
          <Route path="/serviceIndisponible/:errorId" component={ServiceIndisponible} />
          <Route path="/eaLegacyAccueil" component={EaLegacyAccueil} />
          <Route path="/sessionExpire" component={SessionExpire} />
          <Route path="/clap/:mode" component={DemandeClap} />
          <Route path="/choixFormulairePrestation/:casCodeList" component={ChoixFormulairePrestation} />
          <Route path="/choixPeriode" component={ChoixPeriode} />
          <Route path="/prepaiement" component={PrePaiement} />
          <Route path="/vacances/:mode" component={DemandeVacances} />
          <Route path="/choixPeriodeVacances/:codeCas" component={ChoixPeriodeVacances} />
          <Route path="/sports/:mode" component={DemandeSport} />
          <Route path="/ChoixPeriodeSports/:codeCas" component={ChoixPeriodeSport} />
          <Route path="/DemandeChangementRib/:mode" component={DemandeChangementRib} />
          <Route path="/ChoixRib" component={ChoixRib} />
          <Route path="/choixPeriodeAncv/:codeCas" component={ChoixPeriodeAncv} />
          <Route path="/ancv/:mode" component={DemandeAncv} />
          <Route path="/choixPeriodeCesu/:codeCas" component={ChoixPeriodeCesu} />
          <Route path="/cesu/:mode" component={DemandeCesu} />
          <Route path="/choixPeriodeCesuMulti/:codeCas" component={ChoixPeriodeCesuMulti} />
          <Route path="/cesuMulti/:mode" component={DemandeCesuMulti} />
        </div>

        <AppFooter layoutColorMode={layoutColorMode} />
      </div>

      <CSSTransition
        classNames="layout-mask"
        timeout={{ enter: 200, exit: 200 }}
        in={mobileMenuActive}
        unmountOnExit
      >
        <div className="layout-mask p-component-overlay"></div>
      </CSSTransition>

      <Dialog closable={false} header="" visible={jweExpired} modal>
        <center>
          <h3 style={{ color: "#932823" }}>
            Page expirée car ouverte depuis trop longtemps.
          </h3>
          <br />
          <br />
          <button
            type="button"
            onClick={onRetourAccueilJweExpired}
            className="retour-accueil-btn"
            id="retour-accueil-jwe-expired"
            style={{
              color: "#ffffff",
              backgroundColor: "#2A7D93",
              border: "1px solid #999898",
              padding: "1rem 2rem",
              fontSize: "1rem",
              borderRadius: "5px",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#39b0c8")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#2A7D93", e.currentTarget.style.bordorColo = "#2A7D93")}
          >
            RETOUR A LA LISTE DES PRESTATIONS
          </button>
          <br />
        </center>
      </Dialog>
    </div>
  );
};

export default App;
